/**
 * ScrollToTop Component
 *
 * React Router v6에서 페이지 전환 시 스크롤을 최상단으로 이동합니다.
 * 브라우저의 기본 동작을 모방하여 새 페이지를 방문할 때 항상 상단에서 시작합니다.
 */

import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

export function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    // 페이지 경로가 변경될 때마다 스크롤을 최상단으로 이동
    // DashboardLayout의 <main> 스크롤 컨테이너 우선, 없으면 window fallback
    const mainEl = document.getElementById('main-scroll-container');
    if (mainEl) {
      mainEl.scrollTo(0, 0);
    } else {
      window.scrollTo(0, 0);
    }
  }, [pathname]);

  return null;
}

export default ScrollToTop;
